import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const FontSelectorRow = dt7948.c(class FontSelectorRow extends SelectKitRowComponent {}, [classNames("font-selector-row")]);
export default FontSelectorRow;